import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  resetSearchParamsForCategory,
  setSearchLoading,
} from '@backrs_ui/grow-ui/src/redux/search/search';

import { SearchCategory, SearchPageCategory } from '../search.types';
import { handleInitiateSearch } from '../search.util';

type UsePaginationProps = Readonly<{
  currentSearchTerm: string;
  selectedFilters: SearchCategory[];
  currentPageCategory: SearchPageCategory;
  currentPage?: number;
}>;

export const usePagination = ({
  currentSearchTerm,
  selectedFilters,
  currentPageCategory,
  currentPage = 1,
}: UsePaginationProps) => {
  const dispatch = useAppDispatch();

  const handleNextPage = () => {
    dispatch(setSearchLoading(true));

    handleInitiateSearch({
      dispatch,
      currentSearchTerm,
      pageNum: currentPage + 1,
      items: selectedFilters,
      searchPageCategory: currentPageCategory,
    });
  };

  const handlePrevPage = () => {
    dispatch(setSearchLoading(true));

    handleInitiateSearch({
      dispatch,
      currentSearchTerm,
      pageNum: currentPage - 1,
      items: selectedFilters,
      searchPageCategory: currentPageCategory,
    });
  };

  const handleSelectPage = (pageNum: number) => {
    dispatch(setSearchLoading(true));

    handleInitiateSearch({
      dispatch,
      currentSearchTerm,
      pageNum,
      items: selectedFilters,
      searchPageCategory: currentPageCategory,
    });
  };

  const clearSearch = () => {
    dispatch(resetSearchParamsForCategory(currentPageCategory));
  };

  return {
    handleNextPage,
    handlePrevPage,
    handleSelectPage,
    clearSearch,
  };
};
